<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    title="代码模板"
    namespace="wechat_third_party_platform/"
    resource="templates"
    :actionButtons="[]"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Template extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    return [
      {
        prop: 'user_version',
        label: '版本号'
      },
      {
        prop: 'user_desc',
        label: '描述',
        width: 400
      },
      {
        prop: 'template_id',
        label: '模板ID'
      },
      {
        prop: 'create_time',
        label: '添加到模板库时间',
        renderCell: 'time'
      },
      {
        prop: 'is_latest',
        label: '最新的',
        renderCell: 'bool'
      }
    ];
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    const env = process.env.VUE_APP_ENV;
    const handleUpdateTemplateSetting = async (id) => {
      await this.$autoLoading(this.$request.put('/wechat_third_party_platform/template_settings', { latest_template_id: id }));
      this.$message.success('操作成功');
      reload()
    }

    let canRemove = false

    if (env === 'production' && !row.is_latest) {
      canRemove = true
    }

    return [
      !row.is_latest && {
        component: 'confirmButton',
        props: {
          label: '设为最新模板',
          type: 'primary',
          can: 'template_settings.update'
        },
        on: {
          confirm: () => handleUpdateTemplateSetting(row.id)
        }
      },
      canRemove && {
        component: 'confirmButton',
        props: {
          label: '删除',
          type: 'danger',
          can: 'templates.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      },
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/templates',
    name: 'templates.index',
    component: Template,
    props: {
      type: 'index',
    }
  },
]
</script>
